import { Button, DatePicker, Input, Select } from "antd";
import { CaretDownFilled, CaretUpOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useAdmin } from "../../context/adminContext";
import { useMerchant } from "../../context/merchantContext";

const SearchDatePickerInvoice = ({ title, fieldName, sort = true }) => {
  const { searchFieldsInvoice, setSearchFieldsInvoice, showFilter } =
    useMerchant();
  const valueChange = (e) => {
    var query = { ...searchFieldsInvoice };
    if (e == null) {
      query[fieldName] = null;
      return setSearchFieldsInvoice(query);
    }
    if (!e || e.length !== 2) return;

    var dates = [dayjs(e[0]).startOf("day"), dayjs(e[1]).endOf("day")];
    query[fieldName] = dates;
    setSearchFieldsInvoice(query);
  };
  const sortChange = (sort) => {
    setSearchFieldsInvoice({
      ...searchFieldsInvoice,
      sort: sort,
      sortField: fieldName,
    });
  };
  return (
    <div key={fieldName}>
      {sort && (
        <div className="titleWithSort">
          <span style={{ fontSize: 12 }}>{title}</span>
          <div className="sortIcons">
            <CaretUpOutlined
              className="sortIcon"
              style={{ color: "#46CE7C" }}
              onClick={() => sortChange("asc")}
            />
            <CaretDownFilled
              className="sortIcon"
              style={{ color: "#46CE7C" }}
              onClick={() => sortChange("desc")}
            />
          </div>
        </div>
      )}
      {showFilter && (
        <>
          <div className="line" />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DatePicker.RangePicker
              size="small"
              style={{ width: "90%" }}
              placeholder="Хайх утга"
              className="text-xs"
              value={searchFieldsInvoice && searchFieldsInvoice[fieldName]}
              onChange={valueChange}
            />
          </div>
        </>
      )}
    </div>
  );
};
export default SearchDatePickerInvoice;
